module.exports = __webpack_public_path__ + "img/zimg5.bc3d70c1.png";